export default __webpack_public_path__ + "static/media/Montserrat-BlackItalic.4404f7c6.ttf";